import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap/collapse';
import { RouterLink } from '@angular/router';
import { LessonHelpComponent } from '../../lesson/shared/lesson-help/lesson-help.component';

@Component({
    selector: 'app-exercise-problem',
    templateUrl: './exercise-problem.component.html',
    styleUrls: ['./exercise-problem.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgbCollapse, RouterLink, LessonHelpComponent]
})
export class ExerciseProblemComponent implements OnInit {

  public hintCollapsed = true;

  constructor() { }

  ngOnInit() {
  }

}
